import React from 'react';
import { ArticleBodyComponent, ArticleBodyContentType } from '../../../../components/ArticleBodyComponent';
import { ScrollToTop } from '../../../../components/ScrollToTop';
import { CamelizedTrainingGuideResponse } from '../../../../types/app/training-guide';
import { LazyYoutube } from '../../../../wag-react/components/lazyload/LazyYoutube';
import { Box } from '../../../../wag-react/next-components/box';
export type TrainingBodyContentProps = Pick<CamelizedTrainingGuideResponse, 'body'>;
export const TrainingBodyContent = ({
  body
}: TrainingBodyContentProps) => <Box px={['16px', 0]} data-sentry-element="Box" data-sentry-component="TrainingBodyContent" data-sentry-source-file="index.tsx">
    {body.map(item => <>
        <ArticleBodyComponent key={JSON.stringify(item)} value={item} overrides={{
      video_link: ({
        url
      }) => <>
                {url && <LazyYoutube src={url} height={['192px', '464px']} my={['24px', '32px']} width={1} />}
              </>
    }} />

        {item.type === ArticleBodyContentType.Paragraph && <ScrollToTop display={['flex', 'none']} />}
      </>)}
  </Box>;